export default __webpack_public_path__ + "static/stars-background-ef88a6ee312156368fb44d770fe9ce21.png";